
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"44","viewBox":"0 0 24 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.755 39.6585L20.222 43.1881L0.978808 23.9516C0.668617 23.6434 0.422446 23.2768 0.254463 22.8731C0.0864785 22.4693 -1.92648e-06 22.0364 -1.88825e-06 21.5991C-1.85002e-06 21.1618 0.0864787 20.7288 0.254463 20.325C0.422447 19.9213 0.668618 19.5548 0.978808 19.2465L20.222 1.76786e-06L23.7516 3.52964L5.69054 21.5941L23.755 39.6585Z","fill":"#5D8ECA"}})])
          )
        }
      }
    